/** Global Imports */
import React from 'react';

/** Component Imports */
import { renderRouter } from 'router';

export default function Home() {
  return <div>{renderRouter()}</div>;
}
